import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

export default function deeperMerge<T>(target: T, source: T): T {
  return merge(cloneDeep(target), cloneDeep(source));
}
